import OrderContainer from '@containers/OrderContainer'
import { Box, Container, Stepper, Step, StepLabel, Paper } from '@mui/material'

const steps = ['注文情報入力画面', '注文情報保存画面']

const Order = () => {
  return (
    <Box>
      <Container sx={{ pl: 1, pr: 1, pb: 1 }} maxWidth={false}>
        <Paper
          sx={{
            p: 0.5,
            mt: 1,
            borderTop: '1px solid #ccc',
            background: '#fff',
          }}
        >
          <Stepper
            sx={{
              display: {
                md: 'flex',
              },
            }}
            activeStep={1}
            alternativeLabel
          >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Paper>
        <OrderContainer />
      </Container>
    </Box>
  )
}

export default Order
